import styled, { css } from 'styled-components';

export const ParsedLink = styled.a`
  color: ${(props) => props.theme.color.primary};
  ${(props) =>
    props.$contrast &&
    css`
      color: ${(props) => props.theme.color.contrast.secondary};
      text-decoration: underline;
    `}
  :hover {
    text-decoration: underline;
  }
`;
